import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { Equipamento } from '@tivic-team/manager-ts/dist/grl';
import { VeiculoEquipamento } from '@tivic-team/manager-ts/dist/mob/entities/veiculo-equipamento.entity';

export class VeiculoEquipamentoDTO extends VeiculoEquipamento{

    equipamento: Equipamento = void(0);
    veiculo: Veiculo = void(0);
    
    constructor() {
        super();
    }
}